import firebase from "firebase/app";
import { getAuth } from "firebase/auth";
// import { getFirestore } from "firebase/app";
import { initializeApp } from "firebase/app";
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBWaUoGOQKGPmIC4lOxw6S10eswXKXaRN8",
  authDomain: "x-95a4c.firebaseapp.com",
  projectId: "x-95a4c",
  storageBucket: "x-95a4c.appspot.com",
  messagingSenderId: "561808319795",
  appId: "1:561808319795:web:71106841878b9406230a46",
  measurementId: "G-XMRF2DBMPQ",
};

const firebaseApp = initializeApp(firebaseConfig);

// const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);

export { auth };
